import * as React from 'react';
import TransferMajorDisciplineFrameworkElementApiService from '../../../api/TransferMajorDisciplineFrameworkElementApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import TransferMajorDisciplineFrameworkElementDTO from '../../../models/TransferMajorDisciplineFrameworkElementDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';
import FileDownload from '../../../utils/FileDownload';
import DateUtil from '../../../utils/DateTimeUtil';

interface TransferMajorDisciplineFrameworkElementDataTableProps extends BaseFormProps {
}

interface TransferMajorDisciplineFrameworkElementDataTableState extends BaseDataTableState<TransferMajorDisciplineFrameworkElementDTO>, BaseFormState {
}

class TransferMajorDisciplineFrameworkElementDataTable extends React.Component<TransferMajorDisciplineFrameworkElementDataTableProps, TransferMajorDisciplineFrameworkElementDataTableState> {
  private _dataTable: DataTable<TransferMajorDisciplineFrameworkElementDTO> | undefined;

  constructor(props: TransferMajorDisciplineFrameworkElementDataTableProps) {
    super(props);
    this.state = {
    };
  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Name',
        dataIndex: TransferMajorDisciplineFrameworkElementDTO.name,
        sorter: true,
        filterType: FilterType.Text
      }
    ] as DataTableColumnProps<any>[];
  };

  private openTransferMajorDisciplineFrameworkElement = (record: TransferMajorDisciplineFrameworkElementDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.TRANSFER_MAJOR_DISCIPLINE_FRAMEWORK_ELEMENT_DETAILS, { id: record.id }, {}));
    }
  }

  private addTransferMajorDisciplineFrameworkElement = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_TRANSFER_MAJOR_DISCIPLINE_FRAMEWORK_ELEMENT));
  }

  render() {
    const actionButtons = [];

    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return TransferMajorDisciplineFrameworkElementApiService.getTransferMajorDisciplineFrameworkElementDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`Transfer_Major_Discipline_Element_${DateUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );

    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_TRANSFER_MAJOR_DISCIPLINE_FRAMEWORKS])) {
      actionButtons.push(DataTableButtonUtil.Default('New Discipline Framework Element', () => this.addTransferMajorDisciplineFrameworkElement()));
    }

    return (
      <>
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openTransferMajorDisciplineFrameworkElement}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => TransferMajorDisciplineFrameworkElementApiService.getTransferMajorDisciplineFrameworkElementsDataTable(requestState)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'transferMajorDisciplineFrameworkElement_list' }} />
      </>
    );
  }
}

export default TransferMajorDisciplineFrameworkElementDataTable;
